import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { onKeyStroke } from '@vueuse/core';
import { throttle } from 'lodash-es';
import { saveAs } from 'file-saver';
import { printFile } from '~/core/functions';
import { uuidv4 } from '~/core/utils/uuidv4';
import { formatDate } from '~/core/utils/formatDate';
import FullscreenGalleryToolbarBtn from './FullscreenGalleryToolbarBtn.vue';
import { GALLERY_TOOLBAR_HEIGHT } from './constants';
import { useMultipleTouchActive } from './composables';
import FullscreenGalleryItem from './FullscreenGalleryItem.vue';
export default defineComponent({
  name: 'FullscreenGalleryContent',
  components: {
    FullscreenGalleryToolbarBtn: FullscreenGalleryToolbarBtn,
    FullscreenGalleryItem: FullscreenGalleryItem
  },
  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    index: {
      type: Number,
      default: 0
    },
    downloadable: {
      type: Boolean,
      default: true
    },
    printable: {
      type: Boolean,
      default: false
    },
    deletable: {
      type: Boolean,
      default: false
    },
    comparable: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    }
  },
  emits: ['hide', 'delete', 'document:open', 'update:index', 'compare'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      expose = _ref.expose;
    var isDocumentsUpdate = false;
    var oldFiles = ref([]);
    var registeredGalleryItems = ref([]);
    var fileIndex = ref(props.index);
    var _useNuxtApp = useNuxtApp(),
      $device = _useNuxtApp.$device;
    var isMultipleTouch = useMultipleTouchActive();
    var isFocused = ref(false);
    var handleClickOutside = function handleClickOutside() {
      isFocused.value = false;
    };
    var innerFilesSources = computed(function () {
      return oldFiles.value.map(function (_ref2) {
        var source = _ref2.source;
        return {
          getSource: source,
          uuid: uuidv4()
        };
      });
    });
    var currentGalleryItemIndex = computed(function () {
      return registeredGalleryItems.value.findIndex(function (_ref3) {
        var index = _ref3.index;
        return index === fileIndex.value;
      });
    });
    var currentGalleryItem = computed(function () {
      var _registeredGalleryIte;
      return (_registeredGalleryIte = registeredGalleryItems.value[currentGalleryItemIndex.value]) !== null && _registeredGalleryIte !== void 0 ? _registeredGalleryIte : null;
    });
    var isCurrentGalleryItemLoaded = computed(function () {
      return Boolean(currentGalleryItem.value);
    });
    var isLeftArrowShow = computed(function () {
      return props.index > 0;
    });
    var isRightArrowShow = computed(function () {
      return props.index < props.files.length - 1;
    });
    var fileName = computed(function () {
      var _props$files$fileInde, _props$files$fileInde2;
      return (_props$files$fileInde = (_props$files$fileInde2 = props.files[fileIndex.value]) === null || _props$files$fileInde2 === void 0 ? void 0 : _props$files$fileInde2.name) !== null && _props$files$fileInde !== void 0 ? _props$files$fileInde : '';
    });
    var fileDate = computed(function () {
      var _props$files$fileInde3;
      return (_props$files$fileInde3 = props.files[fileIndex.value]) !== null && _props$files$fileInde3 !== void 0 && _props$files$fileInde3.date ? formatDate(props.files[fileIndex.value].date, 'dd.MM.yyyy') : '';
    });
    watch(function () {
      return props.index;
    }, function (val) {
      var _props$files;
      if (!isDocumentsUpdate && oldFiles.value.length === ((_props$files = props.files) === null || _props$files === void 0 ? void 0 : _props$files.length)) {
        fileIndex.value = val;
      }
    });
    watch(fileIndex, function (val) {
      emit('update:index', val);
    });
    watch(function () {
      return props.files;
    }, function (val) {
      if (innerFilesSources.value.length > 0 && oldFiles.value[fileIndex.value].id === val[props.index].id) {
        isDocumentsUpdate = true;
        return;
      }
      updateDocuments();
    }, {
      immediate: true,
      deep: true
    });
    function updateDocuments() {
      return _updateDocuments.apply(this, arguments);
    }
    function _updateDocuments() {
      _updateDocuments = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              oldFiles.value = _toConsumableArray(props.files);
              registeredGalleryItems.value = [];
              fileIndex.value = props.index;
              isDocumentsUpdate = false;
              _context.next = 6;
              return nextTick();
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _updateDocuments.apply(this, arguments);
    }
    function handleTouch(direction) {
      if (isMultipleTouch.value || isCurrentGalleryItemLoaded.value && currentGalleryItem.value.isZoomApplied()) {
        return;
      }
      if (direction === 'left') {
        prevFile();
        return;
      }
      nextFile();
    }
    function zoom(zoomFactor) {
      if (!isCurrentGalleryItemLoaded.value) {
        return;
      }
      currentGalleryItem.value.zoom(zoomFactor);
    }
    function downloadCurrentFile() {
      if (!isCurrentGalleryItemLoaded.value) {
        return;
      }
      var currentFile = currentGalleryItem.value.file;
      saveAs(currentFile, currentFile.name);
    }
    function printCurrentFile() {
      if (!isCurrentGalleryItemLoaded.value) {
        return;
      }
      var currentFile = currentGalleryItem.value.file;
      printFile(currentFile);
    }
    var isArrowsShown = computed(function () {
      return !$device.isMobile;
    });
    function registerGalleryItem(payload, index) {
      emit('document:open', index);
      registeredGalleryItems.value.push(_objectSpread(_objectSpread({}, payload), {}, {
        index: index
      }));
    }
    var changeIndex = throttle(function (val) {
      fileIndex.value += val;
    }, 100);
    function nextFile() {
      return _nextFile.apply(this, arguments);
    }
    function _nextFile() {
      _nextFile = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!isDocumentsUpdate) {
                _context2.next = 3;
                break;
              }
              _context2.next = 3;
              return updateDocuments();
            case 3:
              if (!(fileIndex.value === innerFilesSources.value.length - 1)) {
                _context2.next = 5;
                break;
              }
              return _context2.abrupt("return");
            case 5:
              changeIndex(1);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _nextFile.apply(this, arguments);
    }
    function prevFile() {
      return _prevFile.apply(this, arguments);
    }
    function _prevFile() {
      _prevFile = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!isDocumentsUpdate) {
                _context3.next = 3;
                break;
              }
              _context3.next = 3;
              return updateDocuments();
            case 3:
              if (!(fileIndex.value === 0)) {
                _context3.next = 5;
                break;
              }
              return _context3.abrupt("return");
            case 5:
              changeIndex(-1);
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return _prevFile.apply(this, arguments);
    }
    onKeyStroke('ArrowRight', function (e) {
      if (!isFocused.value) {
        return;
      }
      e.preventDefault();
      nextFile();
    }, {
      eventName: 'keydown'
    });
    onKeyStroke('ArrowLeft', function (e) {
      if (!isFocused.value) {
        return;
      }
      e.preventDefault();
      prevFile();
    }, {
      eventName: 'keydown'
    });
    function handleDeleteFile() {
      if (innerFilesSources.value.length === 1) {
        emit('hide');
      }
      var deleteIndex = fileIndex.value;
      if (fileIndex.value === innerFilesSources.value.length - 1) {
        fileIndex.value--;
      } else {
        fileIndex.value++;
      }
      innerFilesSources.value.splice(deleteIndex, 1);
      emit('delete', deleteIndex);
    }
    function handleCompare() {
      emit('compare');
    }
    function focus() {
      isFocused.value = true;
    }
    function blur() {
      isFocused.value = false;
    }
    expose({
      focus: focus,
      blur: blur
    });
    return {
      fileName: fileName,
      fileDate: fileDate,
      handleCompare: handleCompare,
      handleDeleteFile: handleDeleteFile,
      handleTouch: handleTouch,
      zoom: zoom,
      downloadCurrentFile: downloadCurrentFile,
      printCurrentFile: printCurrentFile,
      registerGalleryItem: registerGalleryItem,
      isCurrentGalleryItemLoaded: isCurrentGalleryItemLoaded,
      isArrowsShown: isArrowsShown,
      fileIndex: fileIndex,
      innerFilesSources: innerFilesSources,
      GALLERY_TOOLBAR_HEIGHT: GALLERY_TOOLBAR_HEIGHT,
      isFocused: isFocused,
      isLeftArrowShow: isLeftArrowShow,
      isRightArrowShow: isRightArrowShow,
      handleClickOutside: handleClickOutside,
      prevFile: prevFile,
      nextFile: nextFile
    };
  }
});